<div class="wrapper">
  <h1>ขอบคุณสำหรับการลงทะเบียน</h1>
  <p>ระบบจะส่งข้อความที่ระบุเลขที่ใบรับประกัน ไปยังหมายเลขโทรศัพท์มือถือของผู้ซื้อที่ได้ลงทะเบียนไว้</p>
  <address>
    ในกรณีที่ไม่ได้รับใบรับประกันยางรถยนต์ดังกล่าว กรุณาติดต่อ <a
      href="mailto:admin@tsiam.co.th">admin&#64;tsiam.co.th</a>
  </address>
  <button mat-flat-button (click)="goBack()">Back</button>
</div>